'use strict';

const $ = jQuery.noConflict();

$(function() {
	const DESKTOP_BREAKPOINT = 991;
	const WHEEL_ANGLE_STEP = 8;

	const stopsMobile = [
		{d: -2, xPercent: -50, xVw: -132, yPercent: -50, rotate: 0, opacity: 0},
		{d: -1, xPercent: -50, xVw: -90, yPercent: -50, rotate: 0, opacity: 1},
		{d: 0, xPercent: -50, xVw: 0, yPercent: -50, rotate: 0, opacity: 1},
		{d: 1, xPercent: -50, xVw: 90, yPercent: -50, rotate: 0, opacity: 1},
		{d: 2, xPercent: -50, xVw: 132, yPercent: -50, rotate: 0, opacity: 0},
	];

	const onOurPlate = {
		totalCards: 0,
		currentIndex: 0,
		renderedIndex: 0,
		rafId: null,
		$ghostPrev: null,
		$ghostNext: null,

		init: function() {
			this.cacheDOM();

			if (!this.$section.length || !this.$rail.length) {
				return;
			}

			this.totalCards = this.$cards.length;

			const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

			if (prefersReduced || this.totalCards < 2) {
				return;
			}

			this.$section.addClass('on-our-plate--animated');
			this.createGhosts();
			this.setTrackHeight();
			this.renderedIndex = this.getTargetIndex();
			this.render();
			this.bindEvents();
		},

		cacheDOM: function() {
			this.$section = $('.js-on-our-plate');
			this.$scrollTrack = $('.js-on-our-plate-scroll-track');
			this.$sticky = $('.js-on-our-plate-sticky');
			this.$rail = $('.js-on-our-plate-rail');
			this.$cards = this.$rail.find('.on-our-plate__card');
			this.$announcement = $('.js-on-our-plate-announcement');
		},

		createGhosts: function() {
			this.$ghostPrev = this.$cards.last().clone()
				.removeClass('is-active is-prev is-next is-before')
				.addClass('on-our-plate__card--ghost')
				.attr('aria-hidden', 'true')
				.removeAttr('data-index');

			this.$ghostNext = this.$cards.first().clone()
				.removeClass('is-active is-prev is-next is-before')
				.addClass('on-our-plate__card--ghost')
				.attr('aria-hidden', 'true')
				.removeAttr('data-index');

			this.$rail.prepend(this.$ghostPrev);
			this.$rail.append(this.$ghostNext);
		},

		setTrackHeight: function() {
			this.$scrollTrack.height(this.totalCards * window.innerHeight);
		},

		getProgress: function() {
			const trackTop = this.$scrollTrack[0].getBoundingClientRect().top;
			const trackHeight = this.$scrollTrack[0].offsetHeight;
			const viewportH = window.innerHeight;
			const scrollable = trackHeight - viewportH;

			if (scrollable <= 0) {
				return 0;
			}

			const scrolled = -trackTop;

			return Math.max(0, Math.min(1, scrolled / scrollable));
		},

		getTargetIndex: function() {
			return this.getProgress() * (this.totalCards - 1);
		},

		lerp: function(a, b, t) {
			return a + (b - a) * t;
		},

		interpolateMobileDelta: function(delta) {
			const stops = stopsMobile;
			const clamped = Math.max(-2, Math.min(2, delta));

			let lower = stops[0];
			let upper = stops[stops.length - 1];

			for (let i = 0; i < stops.length - 1; i++) {
				if (clamped >= stops[i].d && clamped <= stops[i + 1].d) {
					lower = stops[i];
					upper = stops[i + 1];
					break;
				}
			}

			const range = upper.d - lower.d;
			const t = range === 0 ? 0 : (clamped - lower.d) / range;

			return {
				xPercent: this.lerp(lower.xPercent, upper.xPercent, t),
				xVw: this.lerp(lower.xVw, upper.xVw, t),
				yPercent: this.lerp(lower.yPercent, upper.yPercent, t),
				rotate: this.lerp(lower.rotate, upper.rotate, t),
				opacity: this.lerp(lower.opacity, upper.opacity, t),
			};
		},

		getZIndex: function(delta) {
			const distance = Math.abs(delta);

			if (distance < 0.5) {
				return 3;
			}

			return distance < 1.5 ? 2 : 1;
		},

		applyTransform: function($card, delta) {
			const isMobile = window.innerWidth <= DESKTOP_BREAKPOINT;
			let transform;
			let opacity;

			if (isMobile) {
				const pos = this.interpolateMobileDelta(delta);
				transform = 'translate(calc(' + pos.xPercent + '% + ' + pos.xVw + 'vw), ' + pos.yPercent + '%) rotate(' + pos.rotate + 'deg)';
				opacity = pos.opacity;
			} else {
				const angle = delta * WHEEL_ANGLE_STEP;
				transform = 'translate(-50%, -50%) rotate(' + angle + 'deg)';
				opacity = Math.max(0, Math.min(1, 1 - (Math.abs(delta) - 1)));
			}

			$card.css({
				transform: transform,
				opacity: opacity,
				zIndex: this.getZIndex(delta),
				pointerEvents: Math.abs(delta) < 0.5 ? 'auto' : 'none',
			});
		},

		render: function() {
			this.$cards.each((i, card) => {
				this.applyTransform($(card), i - this.renderedIndex);
			});

			this.applyTransform(this.$ghostPrev, -1 - this.renderedIndex);
			this.applyTransform(this.$ghostNext, this.totalCards - this.renderedIndex);

			const roundedIndex = Math.max(0, Math.min(this.totalCards - 1, Math.round(this.renderedIndex)));

			if (roundedIndex !== this.currentIndex) {
				this.currentIndex = roundedIndex;
				this.announceCard(roundedIndex);
			}
		},

		animate: function() {
			const target = this.getTargetIndex();

			this.renderedIndex = this.lerp(this.renderedIndex, target, 0.15);

			if (Math.abs(target - this.renderedIndex) > 0.001) {
				this.render();
				this.rafId = requestAnimationFrame(() => this.animate());
			} else {
				this.renderedIndex = target;
				this.render();
				this.rafId = null;
			}
		},

		announceCard: function(index) {
			const label = this.$cards.eq(index).attr('aria-label') || '';
			const message = label ? label + ', ' + (index + 1) + ' of ' + this.totalCards : '';

			this.$announcement.text('');
			setTimeout(() => {
				this.$announcement.text(message);
			}, 50);
		},

		bindEvents: function() {
			$(window).on('scroll.onOurPlate', this.onScroll.bind(this));
			$(window).on('resize.onOurPlate', this.handleResize.bind(this));
		},

		onScroll: function() {
			if (!this.rafId) {
				this.rafId = requestAnimationFrame(() => this.animate());
			}
		},

		handleResize: function() {
			this.setTrackHeight();
			this.renderedIndex = this.getTargetIndex();
			this.render();
		},
	};

	onOurPlate.init();
});
